import { render, staticRenderFns } from "./MessageInbox.vue?vue&type=template&id=23a03758"
import script from "./MessageInbox.vue?vue&type=script&lang=js"
export * from "./MessageInbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports